import { render } from "./treemap.vue?vue&type=template&id=2fd6a84c&scoped=true"
import script from "./treemap.vue?vue&type=script&lang=js"
export * from "./treemap.vue?vue&type=script&lang=js"

import "./treemap.vue?vue&type=style&index=0&id=2fd6a84c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd6a84c"]])

export default __exports__